import React, { useEffect, useRef } from "react";

// Injects one of TradingView's free embeddable widgets (https://www.tradingview.com/widget/).
// These are explicitly built for embedding on third-party sites, load live from TradingView,
// and need no API key or backend - just a script tag with a JSON config.
const TradingViewWidget = ({ scriptSrc, config, height = 400 }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.innerHTML = "";

    const widgetDiv = document.createElement("div");
    widgetDiv.className = "tradingview-widget-container__widget";
    container.appendChild(widgetDiv);

    const script = document.createElement("script");
    script.src = scriptSrc;
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify(config);
    container.appendChild(script);
  }, [scriptSrc, config]);

  return (
    <div className="tradingview-widget-container" ref={containerRef} style={{ height }} />
  );
};

export default TradingViewWidget;
